export const FETCH_ORDERS_REQUESTED = 'orders/ORDERS_REQUESTED';
export const FETCH_ORDERS_SUCCEED = 'orders/ORDERS_SUCCEED';
export const FETCH_ORDERS_FAIL = 'orders/ORDERS_FAIL';

export const FETCH_ORDER_REQUESTED = 'orders/ORDER_REQUESTED';
export const FETCH_ORDER_SUCCEED = 'orders/ORDER_SUCCEED';
export const FETCH_ORDER_FAIL = 'orders/ORDER_FAIL';


export const EDIT_ORDER_REQUESTED = 'orders/EDIT_ORDER_REQUESTED';
export const EDIT_ORDER_SUCCEED = 'orders/EDIT_ORDER_SUCCEED';
export const EDIT_ORDER_FAIL = 'orders/EDIT_ORDER_FAIL';


export const VERIFY_ORDER = 'orders/VERIFY_ORDER';
export const CANCEL_ORDER = 'orders/CANCEL_ORDER';

export const UPDATE_ORDER = 'orders/UPDATE_ORDER';



// WEBPACK FOOTER //
// ./src/store/orders/actionTypes.js